import styled from 'styled-components';

import { commonMaxWidth, respondDown } from 'styles/mixins';
import { Breakpoints, COLORS, hexWithOpacity } from 'styles/style-constants';

export const MainBlock = styled.main`
    flex: 1 0 auto;
`;

export const ExploreBlock = styled.div<{ $hasChosenPairs: boolean }>`
    position: relative;
    ${commonMaxWidth};
    padding: 0 4rem ${({ $hasChosenPairs }) => ($hasChosenPairs ? '0' : '6.6rem')};

    ${respondDown(Breakpoints.md)`
        padding: 0 1.6rem;
    `}
`;

export const PairSearch = styled.div`
    margin-top: -5.5rem;
    height: 17rem;
    background: ${COLORS.surface};
    box-shadow: 0 2rem 3rem ${hexWithOpacity(COLORS.shadow, 6)};
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 1rem 4.8rem 0;
    box-sizing: border-box;

    ${respondDown(Breakpoints.md)`
        margin-top: -3rem;
        padding: 1.6rem;
        margin-bottom: 8rem;
        padding-top: 5rem;
        flex-direction: column;
        height: unset;
    `}
`;

export const ResultsPanel = styled.div`
    margin-top: 3.2rem;
    padding: 2.4rem;
    border-radius: 0.5rem;
    background-color: ${COLORS.surface};
    border: 0.1rem solid ${COLORS.cardBorder};

    ${respondDown(Breakpoints.md)`
        margin-top: 1.6rem;
        padding: 1.6rem;
    `}
`;
